import EE from 'event-emitter';

export default new EE();
